import { jwtDecode } from 'jwt-decode';
export class AuthService {
  static isAuthenticated(): boolean {
    console.log('isAuthenticated');
    return !!localStorage.getItem('jwt');
  }

  static login(token: string): void {
    localStorage.setItem('jwt', token);
  }

  static logout(): void {
    localStorage.removeItem('jwt');
    window.location.href = '/login';
  }

  static getToken(): string | null {
    return localStorage.getItem('jwt');
  }

  static getSecurityGroup() {
    try {
      const jwtToken = this.getToken() as string;
      // Decode the token
      const decodedToken: any = jwtDecode(jwtToken);

      // Access the securityGroup property
      const securityGroup = decodedToken.GroupId;
      return securityGroup;
    } catch (error) {
      console.error('Invalid token or decoding error:', error);
    }
  }
}
